<template>
  <v-container>
    <v-flex xs12>
      <!-- CARD FOR MATCH TIME CONTROL -->
      <v-card v-if="!match_concluded">
        <v-layout row wrap class="mb-1" align-center justify-center>
          <v-subheader class="px-1">Tempo:</v-subheader>
          <v-progress-circular
            :rotate="-90"
            :size="50"
            :width="7"
            :value="period_1_percentage"
            color="teal"
            class="font-weight-bold"
          >
            <!-- {{ match_period + 1 }} -->
            <v-btn icon class="white--text mx-1" color="primary" @click="/*match_period=0*/">
              <v-icon>mdi-numeric-1</v-icon>
            </v-btn>
          </v-progress-circular>
          <v-progress-circular
            :rotate="-90"
            :size="50"
            :width="7"
            :value="period_2_percentage"
            color="teal"
            class="font-weight-bold"
          >
            <v-btn icon class="white--text mx-1" color="primary" @click="/*match_period=1*/">
              <v-icon>mdi-numeric-2</v-icon>
            </v-btn>
          </v-progress-circular>
          <v-btn
            v-if="is_owner"
            :disabled="match_ended || !gameSquad"
            icon
            class="mx-1"
            @click="matchTimeCondition += matchTimeCondition==1? (-1) : (1)"
          >
            <v-icon>{{matchTimeCondition>0? 'fa-pause' : 'fa-play'}}</v-icon>
          </v-btn>
          <v-btn
            v-if="is_owner"
            :disabled="match_ended || !gameSquad || match_period ==1"
            icon
            class="mx-1"
            @click="end_first_half()"
          >
            <v-icon>fa-stop</v-icon>
          </v-btn>
          <div
            class="headline"
          >{{(minutes<10)? '0'+minutes : minutes}}:{{seconds < 10? ('0'+seconds) : seconds}}</div>
        </v-layout>
        <v-alert type="warning" :value="true" v-if="!gameSquad">
          <h4>Escale mais jogadores para a partida!</h4>
        </v-alert>
      </v-card>

      <!-- TABS FOR CHAMP OWNER -->
      <v-tabs
        v-model="teamsTabs"
        grow
        slider-color="green"
        v-if="false && is_owner && !match_concluded"
      >
        <v-tab v-for="(title, index) in matchTeams" :key="'tab'+index">{{title.team_name}}</v-tab>
        <v-tabs-items v-model="teamsTabs">
          <v-tab-item v-for="(team, index) in matchTeams" :key="index">
            <v-card>
              <v-flex xs12>
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-space-around align-center>
                    <v-flex xs12>
                      <!-- <v-card flat> -->
                      <v-layout row wrap justify-space-around>
                        <v-flex xs4 text-xs-center>
                          <v-avatar
                            :size="100"
                            :color="'white' /*index<1? 'primary' : 'blue-grey lighten-2'*/"
                          >
                            <img :src="find_logo(team.team_name)" alt="alt" />
                            <!-- <img v-if="team.team_logo" src='' alt="alt"> -->
                            <!-- <span v-else class="white--text display-3">{{team_inicials(team.team_name)}}</span> -->
                          </v-avatar>
                          <h2 class="text-xs-center">{{team.team_name}}</h2>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field readonly></v-text-field>
                        </v-flex>
                        <v-flex xs3 class="mt-4 mr-4">
                          <v-text-field
                            :value="home_away_goals_2[teamsTabs]"
                            class="mt-1"
                            style="font-size:26px"
                            outline
                            hide-details
                            readonly
                            single-line
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-card-title primary-title v-if="false">
                        <h3>{{team.team_name}}</h3>
                        <v-spacer></v-spacer>
                        <v-btn icon v-if="matchTimeCondition==0" @click="matchTimeCondition=1">
                          <v-icon>fa-play</v-icon>
                        </v-btn>
                        <v-btn icon v-if="matchTimeCondition==1" @click="matchTimeCondition=0">
                          <v-icon>fa-pause</v-icon>
                        </v-btn>
                        <v-btn icon>
                          <v-icon>fa-stop</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-card-actions v-if="false">
                        <v-btn color="green">1º Tempo</v-btn>
                        <v-btn color="green">2º Tempo</v-btn>
                      </v-card-actions>
                      <!-- </v-card> -->
                      <v-card v-if="false && gameSquad==false">
                        <v-btn large color="primary">
                          <v-icon left dark>fa-clipboard-list</v-icon>Escalar Equipe
                        </v-btn>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>

      <!-- VIEW FOR VISITORS -->
      <v-layout
        row
        wrap
        justify-space-around
        align-center
        v-if="true || is_owner || match_concluded"
      >
        <v-flex xs4 text-xs-center>
          <v-avatar :size="64" color="white">
            <img :src="find_logo(oneMatch.attributes.home_team)" alt="alt" />
            <!-- <img v-if="oneMatch.attributes.home_team_logo" src='' alt="alt"> -->
            <!-- <span v-else class="white--text display-3">{{team_inicials(oneMatch.attributes.home_team)}}</span> -->
          </v-avatar>
          <h2 class="text-xs-center">{{oneMatch.attributes.home_team.substring(0,16)}}</h2>
          <v-text-field
            class="mt-1"
            style="font-size:26px"
            outline
            hide-details
            :value="!match_concluded? home_away_goals_2[0] : home_away_goals_concluded[0]"
            readonly
            single-line
          ></v-text-field>
        </v-flex>
        <v-flex xs4 text-xs-center>
          <div class="display-1">X</div>
        </v-flex>
        <v-flex xs4 text-xs-center>
          <v-avatar :size="64" color="white">
            <img :src="find_logo(oneMatch.attributes.away_team)" alt="alt" />
            <!-- <img v-if="oneMatch.attributes.away_team_logo" src='' alt="alt"> -->
            <!-- <span v-else class="white--text display-3">{{team_inicials(oneMatch.attributes.away_team)}}</span> -->
          </v-avatar>
          <h2 class="text-xs-center">{{oneMatch.attributes.away_team.substring(0,16)}}</h2>
          <v-text-field
            class="mt-1"
            style="font-size:26px"
            outline
            hide-details
            :value="!match_concluded? home_away_goals_2[1] : home_away_goals_concluded[1]"
            readonly
            single-line
          ></v-text-field>
        </v-flex>
      </v-layout>

      <!-- BUTTONS FOR MATCH CONTROL  -->
      <v-card v-if="is_owner">
        <template v-if="!match_concluded">
          <v-layout row wrap justify-space-around>
            <!-- fazer vfor para as duas layouts e a cada click tem q entender qual time é -->
            <v-layout
              column
              class="px-1"
              v-for="(team_column, idx) in matchTeams"
              :key="'tcol'+idx"
            >
              <v-btn
                round
                v-if="button.id != 5"
                class="ma-1"
                v-for="(button, index) in buttons"
                :key="'btn'+index"
                @click="buttonAction(button.id, idx)"
                color="primary"
                :disabled="(!match_started && match_current_time==0 && button.id!=5) || (button.id==5 && match_period ==1)"
              >
                <v-icon dark :class="button.class" :color="button.color">{{button.icon}}</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
          <v-btn
            block
            color="primary"
            @click="buttonAction(5)"
            class="white--text"
            :disabled="(match_period ==1 && !match_edited)"
          >
            <v-icon dark left>{{buttons[4].icon}}</v-icon>
            {{buttons[4].name}}
          </v-btn>
          <v-btn block color="light-green accent-3" @click="end_match()" class="primary--text">
            <v-icon left>fa-check-double</v-icon>finalizar partida
          </v-btn>
        </template>
        <template v-if="match_concluded">
          <v-btn block color="red darken-2" @click="edit_match()" class="white--text">
            <v-icon left>refresh</v-icon>Editar partida
          </v-btn>
        </template>
      </v-card>

      <!-- REAL TIME EVENTS -->
      <v-card
        v-if="matchTeams && (oneMatch.attributes.paper || events.length > 0)"
        class="pt-2"
        flat
      >
        <div
          class="mt-1 mb-3 text-xs-center title"
        >Lances {{oneMatch.attributes.match_ended? 'da partida' : 'em tempo real'}}</div>
        <v-layout row wrap v-if="oneMatch.attributes.match_started">
          <v-layout column>
            <!-- <div class="my-1 text-xs-center title" style="font-size:8vw;"> {{matchTeams[0].team_name.substring(0,16)}}</div> -->
            <div class="my-1 text-xs-center">faltas: {{home_fouls}}</div>
            <div
              class="my-1 text-xs-left align-content-center"
              v-for="(event, idx) in home_events"
              :key="'divevH'+idx"
              v-if="true"
            >
              <!-- flat or icon are good to 1.5, fab or text are good to 2.0 -->
              <v-btn
                v-if="is_owner"
                small
                class="ma-0"
                icon
                color="white"
                @click="showPaper({paper_id: event.id}), teamsTabs = 0"
              >
                <v-icon
                  :color="get_color_event(event)"
                  class="mdi-rotate-270"
                >{{get_icon_event(event)}}</v-icon>
              </v-btn>
              <v-icon
                v-if="!is_owner"
                :color="get_color_event(event)"
                class="mdi-rotate-270"
              >{{get_icon_event(event)}}</v-icon>
              {{event.event_time}}' - {{event.player_number? (`${event.player_name.split(' ')[0]} #${event.player_number}`): 'Gol Contra'}}
            </div>
          </v-layout>
          <v-divider vertical></v-divider>
          <v-layout column class="ml-2">
            <!-- <div class="my-1 text-xs-center title" style="font-size:8vw;"> {{matchTeams[1].team_name.substring(0,16)}}</div> -->
            <div class="my-1 text-xs-center">faltas: {{away_fouls}}</div>
            <div
              class="my-1 text-xs-left align-center"
              v-for="(event, idx) in away_events"
              :key="'divevA'+idx"
              v-if="true"
            >
              <v-btn
                v-if="is_owner"
                small
                class="ma-0"
                icon
                color="white"
                @click="showPaper({paper_id: event.id}), teamsTabs = 1"
              >
                <v-icon
                  :color="get_color_event(event)"
                  class="mdi-rotate-270"
                >{{get_icon_event(event)}}</v-icon>
              </v-btn>
              <v-icon
                v-if="!is_owner"
                :color="get_color_event(event)"
                class="mdi-rotate-270"
              >{{get_icon_event(event)}}</v-icon>
              {{event.event_time}}' - {{event.player_number? (`${event.player_name.split(' ')[0]} #${event.player_number}`): 'Gol Contra'}}
            </div>
          </v-layout>
        </v-layout>
      </v-card>
    </v-flex>

    <!-- DIALOG TO ADD INFO (GOALS AND CARDS) -->
    <v-dialog v-model="addInfo" v-if="addInfo" width="500" persistent>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="white--text">
            <v-icon left :color="toolbarIconColor">{{toolbarIcon}}</v-icon>
            {{toolbarText}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="white" flat icon @click="closeInfo()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-subheader>{{matchTeams[teamsTabs].team_name}}</v-subheader>
          <template v-for="(squad, idx) in oneTeamSquad">
            <v-btn
              style="height: 50px; width: 50px"
              color="grey lighten-4"
              large
              icon
              :disabled="own_goal || squad.red > 0 || (clicked_index != null && clicked_index != idx)"
              @click.stop="clicked_method(idx)"
              :key="'btnX'+idx"
            >
              <div class="icon-stack">
                <v-icon
                  large
                  :color="squad.yellows > 0? 'amber' : teamsTabs<1? 'primary': 'blue-grey darken-1'"
                  class="icon-stack-1x"
                >fa-tshirt</v-icon>
                <span
                  :class="[squad.red > 0? 'red--text' : 'white--text', 'icon-stack-3x font-weight-bold']"
                >{{ squad.number }}</span>
              </div>
            </v-btn>
            <!-- {{squad[kind_info]}} -->
          </template>
          <v-layout column v-if="kind_info == 'goals'">
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-btn :flat="!own_goal" color="error" @click="own_goal = !own_goal" round>
              <v-icon left small>fa-exclamation</v-icon>Gol Contra
            </v-btn>
          </v-layout>
          <v-layout column class="mt-3" justify-center v-if="clicked_index != null">
            <v-divider></v-divider>
            Jogador {{oneTeamSquad[clicked_index].number}}: {{oneTeamSquad[clicked_index][kind_info]}} {{kind_translated}}
          </v-layout>
          <v-text-field
            v-if="false"
            type="tel"
            v-model="numberShirt"
            color="primary"
            box
            label="Número do Jogador"
          ></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="primary"
            @click="submitInfo()"
            :disabled="this.clicked_index == null && !this.own_goal"
          >
            <v-icon left>save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG TO ADD NUMBERS TO PLAYERS/SQUADS (SQUAD_NUMBERS) -->
    <v-dialog
      v-model="addPlayers"
      scrollable
      v-if="addPlayers"
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:8px">
        <v-card-title class="pa-0 ma-0">
          <v-toolbar
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            color="primary"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left color="white">fa-plus</v-icon>Escalar jogadores
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="addPlayers=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-tabs v-model="teamsTabs" grow>
            <v-tab v-for="(title, index) in matchTeams" :key="index">{{title.team_name}}</v-tab>
            <v-tabs-items v-model="teamsTabs">
              <v-tab-item v-for="(team, index) in matchTeams" :key="index">
                <v-card>
                  <v-data-table :headers="headersData" :items="team.squads.data" hide-actions>
                    <template slot="items" slot-scope="props">
                      <!-- <td class="text-xs-center"><v-checkbox v-model="props.selected" return-object primary hide-details></v-checkbox></td> -->
                      <td class="text-xs-center">{{ props.item.attributes.player_name }}</td>
                      <td class="text-xs-center">
                        <v-layout row wrap justify-center>
                          <v-flex xs12 text-xs-center>
                            <v-text-field
                              type="tel"
                              single-line
                              prepend-icon="fa-tshirt"
                              mask="##"
                              v-model="props.item.attributes.number"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="primary" round @click="submitSquadNumbers()">
            <v-icon left>save</v-icon>Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG TO END MATCH -->
    <v-dialog
      v-model="dialog_end_match"
      scrollable
      v-if="dialog_end_match"
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:10px">
        <v-card-title class="pa-0 ma-0">
          <v-toolbar
            style="border-top-right-radius:8px;border-top-left-radius:8px"
            color="primary"
            dark
          >
            <v-toolbar-title class="white--text">
              <v-icon left color="white">fa-check-double</v-icon>Finalizar partida
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="white" flat icon @click="dialog_end_match=false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="ending_kind" column hide-details class="mt-0">
            Encerrar
            <v-radio color="primary" label="Normalmente" value="normal"></v-radio>
            <v-radio color="primary" label="Por W.O." value="wo"></v-radio>
            <v-radio color="primary" label="Número insuficiente de atletas" value="number"></v-radio>
          </v-radio-group>
          <template v-if="ending_kind == 'normal'">
            <v-divider class="mt-3"></v-divider>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-layout row wrap justify-space-around align-center class="mt-3">
              <v-flex xs4 text-xs-center>
                <v-avatar :size="70" color="white">
                  <img :src="find_logo(oneMatch.attributes.home_team)" alt="alt" />
                  <!-- <img v-if="oneMatch.attributes.home_team_logo" src='' alt="alt"> -->
                  <!-- <span v-else class="white--text display-3">{{team_inicials(oneMatch.attributes.home_team)}}</span> -->
                </v-avatar>
                <h4 class="text-xs-center">{{oneMatch.attributes.home_team.substring(0,16)}}</h4>
                <v-text-field
                  class="mt-1 headline"
                  outline
                  hide-details
                  :value="home_away_goals_2[0]"
                  readonly
                  single-line
                ></v-text-field>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <div class="display-1">X</div>
              </v-flex>
              <v-flex xs4 text-xs-center>
                <v-avatar :size="70" color="white">
                  <img :src="find_logo(oneMatch.attributes.away_team)" alt="alt" />
                  <!-- <img v-if="oneMatch.attributes.away_team_logo" src='' alt="alt"> -->
                  <!-- <span v-else class="white--text display-3">{{team_inicials(oneMatch.attributes.away_team)}}</span> -->
                </v-avatar>
                <h4 class="text-xs-center">{{oneMatch.attributes.away_team.substring(0,16)}}</h4>
                <v-text-field
                  class="mt-1 headline"
                  outline
                  hide-details
                  :value="home_away_goals_2[1]"
                  readonly
                  single-line
                ></v-text-field>
              </v-flex>
            </v-layout>
          </template>
          <template v-if="ending_kind == 'wo'">
            <v-radio-group v-model="winner_index" column hide-details>
              <v-divider></v-divider>
              <v-divider></v-divider>
              <v-divider></v-divider>Vencedor
              <v-radio color="primary" :label="matchTeams[0].team_name" :value="0"></v-radio>
              <v-radio color="primary" :label="matchTeams[1].team_name" :value="1"></v-radio>
            </v-radio-group>
            <template v-if="winner_index">
              <v-text-field
                v-model="winner_goals"
                type="tel"
                mask="##"
                prepend-icon="mdi-soccer"
                label="Gols"
                hint="Gols do vencedor segundo o regulamento"
              ></v-text-field>
            </template>
          </template>
          <template v-if="ending_kind == 'number'">
            <v-checkbox
              label="Manter resultado atual"
              v-model="actual_result"
              :value="true"
              hide-details
              color="primary"
            ></v-checkbox>
            <template v-if="!actual_result">
              <v-radio-group v-model="winner_index" column hide-details class="mt-0">
                <v-divider></v-divider>
                <v-divider></v-divider>
                <v-divider></v-divider>Vencedor
                <v-radio color="primary" :label="matchTeams[0].team_name" :value="matchTeams[0].id"></v-radio>
                <v-radio color="primary" :label="matchTeams[1].team_name" :value="matchTeams[1].id"></v-radio>
              </v-radio-group>
              <template v-if="winner_index">
                <v-text-field
                  v-model="winner_goals"
                  type="tel"
                  mask="##"
                  prepend-icon="mdi-soccer"
                  label="Gols"
                  hint="Gols do vencedor segundo o regulamento"
                ></v-text-field>
              </template>
            </template>
          </template>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            round
            text
            color="primary"
            @click="confirm_end_match()"
            :disabled="!can_end_match"
          >OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_edit_paper"
      v-if="dialog_edit_paper"
      scrollable
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <h3 class="headline mb-0">Editando Lance</h3>
          <v-spacer></v-spacer>
          <!-- flat or icon are good to 1.5, fab or text are good to 2.0 -->
          <v-btn flat icon color="primary" @click="dialog_edit_paper = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-subheader>Lance atual:</v-subheader>
            <v-icon
              :color="get_color_event(onePaper.attributes)"
              class="mdi-rotate-270"
            >{{get_icon_event(onePaper.attributes)}}</v-icon>
            {{onePaper.attributes.event_time}}' - {{onePaper.attributes.player_number? (`${onePaper.attributes.player_name.split(' ')[0]} #${onePaper.attributes.player_number}`): 'Gol Contra'}}
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex xs3 sm2>
              <v-radio-group v-model="onePaper.event_id" column>
                <v-radio
                  :color="get_color_event(event.attributes)"
                  :value="event.id"
                  v-for="(event, idx) in game_events"
                  :key="'rd'+idx"
                >
                  <template v-slot:label>
                    <v-icon
                      :color="get_color_event(event.attributes)"
                      class="mdi-rotate-270"
                    >{{get_icon_event(event.attributes)}}</v-icon>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs7 sm6 lg4>
              <v-select
                :items="oneTeamSquad"
                item-text="player_name"
                item-value="number_id"
                v-model="onePaper.squad_number_id"
                label="Atleta"
              >
                <template slot="selection" slot-scope="data">
                  <div class="icon-stack mr-2 my-2">
                    <v-icon
                      large
                      :color="teamsTabs<1? 'primary': 'blue-grey darken-1'"
                      class="icon-stack-1x"
                    >fa-tshirt</v-icon>
                    <span
                      :class="['white--text', 'icon-stack-3x font-weight-bold']"
                    >{{ data.item.number }}</span>
                  </div>
                  {{ data.item.player_name }}
                </template>
                <template slot="item" slot-scope="data">
                  <div class="icon-stack mr-2 mb-1">
                    <v-icon
                      large
                      :color="teamsTabs<1? 'primary': 'blue-grey darken-1'"
                      class="icon-stack-1x"
                    >fa-tshirt</v-icon>
                    <span
                      :class="['white--text', 'icon-stack-3x font-weight-bold']"
                    >{{ data.item.number }}</span>
                  </div>
                  {{ data.item.player_name }}
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn flat text @click="submitDeletePaper()" color="error">
            <v-icon left>fa-trash-alt</v-icon>Apagar
          </v-btn>
          <v-btn
            flat
            text
            @click="submitEditPaper()"
            color="primary"
            :disabled="!onePaper.squad_number_id || !onePaper.event_id"
          >
            <v-icon left>fa-save</v-icon>Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <card-loading v-if="loading" :loadText="loadTxt"></card-loading>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
//{ TEMA LOGO IMAGES
import LogoTelasIcarai from "../../../../public/team_logos/TelasIcarai.png";
import LogoConstruborges from "../../../../public/team_logos/Construborges.png";
import LogoAreiasUniao from "../../../../public/team_logos/AreiasUniao.png";
import LogoMoradaNova from "../../../../public/team_logos/MoradaNova.png";
import LogoPSG from "../../../../public/team_logos/PSG.png";
import LogoLeon from "../../../../public/team_logos/Leon.png";
import LogoGLRefrigeracao from "../../../../public/team_logos/GLRefrigeracao.png";
import LogoCatalao from "../../../../public/team_logos/Catalao.png";
import LogoAlessandroEscapamentos from "../../../../public/team_logos/AlessandroEscapamentos.png";
import LogoCAMotos from "../../../../public/team_logos/CAMotos.png";
import LogoPenarol from "../../../../public/team_logos/Penarol.png";
import LogoAmigosAAT from "../../../../public/team_logos/AmigosAAT.png";
import LogoAGN from "../../../../public/team_logos/AGN.png";
import LogoPhoenix from "../../../../public/team_logos/Phoenix.png";
import LogoOSN from "../../../../public/team_logos/OSN.png";
import LogoRBPerdigao from "../../../../public/team_logos/RBPerdigao.png";
//}

export default {
  data() {
    return {
      click_ok: false,
      team_logos: [
        { team_name: "Telas Icaraí", logo: LogoTelasIcarai },
        { team_name: "Construborges", logo: LogoConstruborges },
        { team_name: "Areias União", logo: LogoAreiasUniao },
        { team_name: "Morada Nova", logo: LogoMoradaNova },
        { team_name: "PSG", logo: LogoPSG },
        { team_name: "Leon", logo: LogoLeon },
        { team_name: "GL Refrigeração", logo: LogoGLRefrigeracao },
        { team_name: "Catalão", logo: LogoCatalao },
        {
          team_name: "Alessandro Escapamentos",
          logo: LogoAlessandroEscapamentos
        },
        { team_name: "C&A Motos", logo: LogoCAMotos },
        { team_name: "Peñarol", logo: LogoPenarol },
        { team_name: "Amigos AAT", logo: LogoAmigosAAT },
        { team_name: "AGN", logo: LogoAGN },
        { team_name: "Phoenix", logo: LogoPhoenix },
        { team_name: "OSN", logo: LogoOSN },
        { team_name: "RB Perdigão", logo: LogoRBPerdigao }
      ],
      first: null,

      is_owner2: true,

      time_to_update: 0,

      match_period: 0,
      match_started: false,
      match_period_time: 25 * 60,
      match_current_time: 0,
      time_event: null,
      matchTimeCondition: 0,

      first_half_done: false,
      match_ended: false,
      match_concluded: true,
      match_edited: true,

      dialog_edit_paper: false,

      date: "July 31, 2019 22:30:00",
      now: 0,
      count: 0,

      clicked_index: null,
      kind_info: null,
      is_save: false,

      events: [],
      own_goal: false,

      fouls: [0, 0],
      home_fouls: 10,
      away_fouls: 0,

      loading: false,
      loadText: null,

      teamsTabs: 0,
      gameSquad: true,

      toolbarIcon: null,
      toolbarIconColor: null,
      toolbarText: null,
      addInfo: false,
      addPlayers: false,

      buttons: [
        {
          kind: "goals",
          name: "Gol",
          icon: "mdi-soccer",
          color: "white",
          class: "",
          id: 1
        },
        {
          kind: "fouls",
          name: "Falta",
          icon: "mdi-whistle",
          color: "white",
          class: "",
          id: 2
        },
        {
          kind: "yellows",
          name: "Cartão Amarelo",
          icon: "mdi-cards",
          color: "yellow",
          class: "mdi-rotate-360",
          id: 3
        },
        {
          kind: "red",
          name: "Cartão Vermelho",
          icon: "mdi-cards",
          color: "red",
          class: "mdi-rotate-360",
          id: 4
        },
        {
          name: "Escalar Jogadores",
          icon: "fa-plus",
          color: "white",
          class: "",
          id: 5
        }
      ],

      dialog_end_match: false,
      ending_kind: null,
      winner_index: null,
      winner_index: null,
      winner_goals: null,
      actual_result: true
    };
  },
  computed: {
    game_events() {
      if (this.allEvents) {
        return this.allEvents.filter(
          obj => !obj.attributes.name.includes("match")
        );
      }
    },
    can_end_match() {
      if (this.dialog_end_match && this.ending_kind) {
        if (this.ending_kind != "normal") {
          if (
            this.ending_kind == "number" &&
            !this.actual_result &&
            !this.winner_goals
          ) {
            return false;
          } else if (this.ending_kind == "wo" && !this.winner_goals) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    headersData() {
      let header = [
        {
          text: "Atleta",
          align: "center",
          value: "name",
          sortable: false,
          width: "2%"
        },
        {
          text: "Núm.",
          align: "center",
          value: "number",
          sortable: false,
          width: "1%"
        }
      ];

      return header;
    },
    home_away_goals() {
      return [
        this.matchTeams[0].squads.data
          .map(obj => obj.attributes.goals)
          .reduce((a, b) => {
            return a + b;
          }, 0),
        this.matchTeams[1].squads.data
          .map(obj => obj.attributes.goals)
          .reduce((a, b) => {
            return a + b;
          }, 0)
      ];
    },
    computed_winner_idx() {
      if (this.dialog_end_match) {
        let idx =
          this.home_away_goals_2[0] > this.home_away_goals_2[1]
            ? 0
            : this.home_away_goals_2[0] < this.home_away_goals_2[1]
            ? 1
            : null;
        return idx;
      }
    },
    home_away_goals_concluded() {
      return [
        this.oneMatch.attributes.team_a_goals,
        this.oneMatch.attributes.team_b_goals
      ];
    },
    home_away_goals_2() {
      return [
        this.events.filter(
          obj =>
            obj.team_name == this.matchTeams[0].team_name && obj.kind == "goals"
        ).length,
        this.events.filter(
          obj =>
            obj.team_name == this.matchTeams[1].team_name && obj.kind == "goals"
        ).length
      ];
    },
    matchTeams() {
      if (this.oneMatch) {
        return [
          this.oneMatch.attributes.home_team_data.data.attributes,
          this.oneMatch.attributes.away_team_data.data.attributes
        ];
      }
    },
    oneTeamSquad() {
      // if (this.addInfo){
      return this.matchTeams[this.teamsTabs].squads.data
        .filter(obj => obj.attributes.number != null)
        .map(obj => obj.attributes)
        .sort((a, b) => {
          return a.number < b.number ? -1 : a.number > b.number ? 1 : 0;
        });
      // }
    },
    kind_translated() {
      if (this.kind_info) {
        switch (this.kind_info) {
          case "goals":
            return "gols";
            break;
          case "yellows":
            return "amarelos";
            break;
          case "red":
            return "vermelho";
            break;
          default:
            break;
        }
      }
    },
    seconds() {
      return (this.match_period_time - this.match_current_time) % 60;
    },
    home_events() {
      let team = this.matchTeams[0].team_name;
      return this.events.filter(obj => obj.team_name == team);
    },
    away_events() {
      let team = this.matchTeams[1].team_name;
      return this.events.filter(obj => obj.team_name == team);
    },
    minutes() {
      return (
        Math.trunc((this.match_period_time - this.match_current_time) / 60) % 60
      );
    },
    modifiedDate: function() {
      return Math.trunc(Date.parse(this.date) / 1000);
    },
    period_1_percentage() {
      return this.match_period == 0
        ? (this.match_current_time * 100) / this.match_period_time
        : 100;
    },
    period_2_percentage() {
      return this.match_period == 1
        ? (this.match_current_time * 100) / this.match_period_time
        : this.match_ended
        ? 100
        : 0;
    },
    is_owner() {
      let aux = false;
      if (
        this.user
        // this.user.id == this.oneChampionship.data.attributes.id
      ) {
        aux = true;
      }
      return aux;
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      user: state => state.Users.user,
      allEvents: state => state.Championship.allEvents,
      oneMatch: state => state.Championship.oneMatch,
      onePaper: state => state.Championship.onePaper,
      updateMatchWasGood: state => state.Championship.updateMatchWasGood,
      updateMatchMessage: state => state.Championship.updateMatchMessage,

      createPaperWasGood: state => state.Championship.createPaperWasGood,
      createPaperMessage: state => state.Championship.createPaperMessage,
      updatePaperWasGood: state => state.Championship.updatePaperWasGood,
      updatePaperMessage: state => state.Championship.updatePaperMessage,
      deletePaperWasGood: state => state.Championship.deletePaperWasGood,
      deletePaperMessage: state => state.Championship.deletePaperMessage
    })
  },
  methods: {
    end_first_half() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Terminar o primeiro tempo?",
          text: "Essa ação é irreversível!!",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          let obj = {
            id: this.oneMatch.id,
            // first_half_done:		true, // NOT NEEDED, WILL BE PUT IS SEQUENCE
            match_current_time: this.match_period_time
          };
          if (this.is_owner && !this.match_concluded)
            this.updateMatchTime({ match: obj });
        }
      })();
    },
    submitDeletePaper() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Apagar esse lance?",
          text: "Essa ação é irreversível!!",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          console.log({ paper: this.onePaper });
          this.loading = true;
          this.loadText = "Apagando";
          this.deletePaper({
            paper: this.onePaper,
            match_id: this.oneMatch.id
          });
        }
      })();
    },
    submitEditPaper() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Deseja realizar a edição?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          console.log({ paper: this.onePaper });
          this.loading = true;
          this.loadText = "Salvando";
          this.updatePaper({
            paper: this.onePaper,
            match_id: this.oneMatch.id
          });
        }
      })();
    },
    edit_match() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Deseja editar a partida?",
          text: "Atente-se para não prejudicar os resultados já consolidados",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          this.match_concluded = false;
          let obj = {
            id: this.oneMatch.id,
            match_concluded: false,
            match_edited: true
          };
          this.updateMatch({ match: obj });

          // this.$swal('Entered confirmation: ' + confirmation)
        }
      })();
    },
    end_match() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Deseja finalizar a partida?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          this.dialog_end_match = true;
          // this.$swal('Entered confirmation: ' + confirmation)
        }
      })();
    },
    confirm_end_match() {
      (async () => {
        const { value: confirmation } = await this.$swal({
          title: "Deseja finalizar a partida?",
          text: "Não é possível reverter essa ação",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#003a3e",
          cancelButtonText: "Não"
        });

        if (confirmation) {
          this.submitEndMatch();
          // this.dialog_end_match = true
          // this.$swal('Entered confirmation: ' + confirmation)
        }
      })();
    },
    submitEndMatch() {
      let obj;
      if (this.ending_kind == "normal") {
        obj = {
          id: this.oneMatch.id,
          winner_id:
            this.computed_winner_idx != null
              ? this.matchTeams[this.computed_winner_idx].id
              : null,
          team_a_goals: this.home_away_goals_2[0],
          team_b_goals: this.home_away_goals_2[1],

          match_period: this.match_period,
          match_current_time: this.match_current_time,
          match_started: this.match_started,
          first_half_done: this.first_half_done,
          match_ended: true,
          match_concluded: true
        };
      } else {
        if (this.ending_kind == "wo") {
          obj = {
            id: this.oneMatch.id,
            winner_id: this.matchTeams[this.winner_index].id,
            team_a_goals: this.winner_index == 0 ? this.winner_goals : 0,
            team_b_goals: this.winner_index == 1 ? this.winner_goals : 0,

            match_period: 1,
            match_current_time: 0,
            match_started: true,
            first_half_done: false,
            match_ended: true,
            match_concluded: true
          };
        } else if (this.ending_kind == "number") {
          obj = {
            id: this.oneMatch.id,
            winner_id: this.winner_index
              ? this.matchTeams[this.winner_index].id
              : this.computed_winner_idx != null
              ? this.matchTeams[this.computed_winner_idx].id
              : null,
            team_a_goals:
              this.winner_index == 0
                ? this.winner_goals
                : this.home_away_goals_2[0],
            team_b_goals:
              this.winner_index == 1
                ? this.winner_goals
                : this.home_away_goals_2[1],

            match_period: this.match_period,
            match_current_time: this.match_current_time,
            match_started: this.match_started,
            first_half_done: this.first_half_done,
            match_ended: true,
            match_concluded: true
          };
        }
      }
      console.log({ send_obj: obj });
      this.updateMatch({ match: obj });
    },
    find_logo(name) {
      return this.team_logos.find(obj => obj.team_name == name)
        ? this.team_logos.find(obj => obj.team_name == name).logo
        : "";
    },
    timer_loop() {
      if (this.matchTimeCondition > 0 && this.is_owner) {
        this.match_current_time++;
        // this.now = Math.trunc(new Date().getTime() / 1000)
        // console.log(this.match_current_time);
      }
      this.match_current_time < this.match_period_time * 10 &&
        setTimeout(this.timer_loop, 1000);
    },
    timer_loop_visitor() {
      if (this.is_owner == false && this.match_started && !this.match_ended) {
        this.time_to_update++;
        // this.now = Math.trunc(new Date().getTime() / 1000)
        // console.log(this.match_current_time);
      }
      this.time_to_update < 1000000000000000000 &&
        this.is_owner == false &&
        setTimeout(this.timer_loop_visitor, 1000);
    },
    get_color_event(event) {
      if (event.kind) {
        switch (event.kind) {
          case "goals":
            return "black";
            break;
          case "yellows":
            return "amber";
            break;
          case "red":
            return "red";
            break;
          default:
            break;
        }
      } else if (event.name) {
        switch (event.name) {
          case "goal":
            return "black";
            break;
          case "yellow_card":
            return "amber";
            break;
          case "red_card":
            return "red";
            break;
          default:
            break;
        }
      }
    },
    get_icon_event(event) {
      if (event.kind) {
        switch (event.kind) {
          case "goals":
            return "mdi-soccer";
            break;
          case "yellows":
            return "mdi-card";
            break;
          case "red":
            return "mdi-card";
            break;
          default:
            break;
        }
      } else if (event.name) {
        switch (event.name) {
          case "goal":
            return "mdi-soccer";
            break;
          case "yellow_card":
            return "mdi-card";
            break;
          case "red_card":
            return "mdi-card";
            break;
          default:
            break;
        }
      }
    },
    buttonAction(id, idx) {
      let btn = this.buttons.find(obj => obj.id == id);
      this.kind_info = btn.kind;
      this.toolbarIcon = btn.icon;
      this.toolbarIconColor = btn.color;
      this.toolbarText = btn.name;
      this.addInfo = [1, 3, 4].includes(id) ? true : false;
      this.addPlayers = [5].includes(id) ? true : false;
      if (id == 2) this.compute_team_foul();

      this.teamsTabs = idx != null ? idx : this.teamsTabs;
    },
    compute_team_foul() {
      if (this.teamsTabs < 1) {
        this.home_fouls += 1;
        if (this.home_fouls >= 6)
          alert("Tiro direto para " + this.matchTeams[1].team_name);
      } else {
        this.away_fouls += 1;
        if (this.away_fouls >= 6)
          alert("Tiro direto para " + this.matchTeams[0].team_name);
      }
      // this.teamsTabs> 0? this.away_fouls += 1 : this.home_fouls += 1

      this.kind_info = null;
      console.log(this.matchTeams[this.teamsTabs].fouls);
      this.matchTeams[0].fouls = this.home_fouls;
      this.matchTeams[1].fouls = this.away_fouls;
      console.log(this.matchTeams[this.teamsTabs].fouls);
    },
    submitInfo() {
      if (this.clicked_index != null || this.own_goal) {
        this.is_save = true;
        if (this.kind_info == "yellows") {
          this.oneTeamSquad[this.clicked_index].red =
            this.oneTeamSquad[this.clicked_index][this.kind_info] > 1
              ? 1
              : this.oneTeamSquad[this.clicked_index].red;
        }
        //update match
        //create event nested
        let event = {
          event_id: this.allEvents.find(obj =>
            obj.attributes.name.includes(this.kind_info.substring(0, 3))
          ).id,
          champ_team_id: this.matchTeams[this.teamsTabs].id,
          squad_number_id: !this.own_goal
            ? this.oneTeamSquad[this.clicked_index].number_id
            : null,
          status_id: 1, //active
          match_id: this.oneMatch.id,

          kind: this.kind_info,
          player_number: !this.own_goal
            ? this.oneTeamSquad[this.clicked_index].number
            : null,
          player_name: !this.own_goal
            ? this.oneTeamSquad[this.clicked_index].name
            : null,
          event_time: this.time_event,
          team_name: this.matchTeams[this.teamsTabs].team_name
        };
        this.events.push(event);
      }
      this.closeInfo();
    },
    closeInfo() {
      if (this.is_save) {
        let last_event = this.events.pop();

        if (!this.oneMatch.attributes.match_edited) {
          let arr = this.oneTeamSquad.map(obj => {
            return {
              goals: obj.goals,
              number: obj.number,
              yellow_cards: obj.yellows,
              red_card: obj.red ? obj.red : obj.yellows >= 2 ? 1 : 0,
              id: obj.number_id
            };
          });
          let obj = {
            id: this.oneMatch.id,
            // match_period: 			this.match_period,
            // match_current_time: this.match_current_time,
            // match_started: 			this.match_started,
            // first_half_done: 		this.first_half_done,
            // match_ended: 				this.match_ended,

            team_a_goals:
              this.teamsTabs == 0 && this.kind_info == "goals"
                ? this.home_away_goals_2[0] + 1
                : this.home_away_goals_2[0],
            team_b_goals:
              this.teamsTabs == 1 && this.kind_info == "goals"
                ? this.home_away_goals_2[1] + 1
                : this.home_away_goals_2[1],

            team_a_fouls: this.home_fouls,
            team_b_fouls: this.away_fouls,

            papers_attributes: [last_event],
            squad_numbers_attributes: [...arr]
          };
          console.log({ obj });
          this.updateMatch({ match: obj });
        } else {
          this.createPaper({ paper: last_event, match_id: this.oneMatch.id });
        }
      } else {
        if (this.clicked_index) {
          this.oneTeamSquad[this.clicked_index][this.kind_info]--;
        }
      }
      this.kind_info = null;
      this.clicked_index = null;
      this.addInfo = false;
      this.own_goal = false;
    },
    clicked_method(idx) {
      if (this.clicked_index != null) {
        this.oneTeamSquad[idx][this.kind_info]--;
        this.clicked_index = null;
        this.time_event = null;
      } else if (this.clicked_index == null) {
        // this.time_event = Math.trunc(this.match_current_time / 60 ) % 60 + 1 + this.match_period_time*this.match_period/60
        this.clicked_index = idx;
        this.oneTeamSquad[idx][this.kind_info]++;
      }
    },

    team_inicials(team) {
      let first_letter = team.charAt(0).toUpperCase();
      let last_letter;
      let team_array = team.split(" ");
      if (team_array.length > 1) {
        last_letter = team_array[team_array.length - 1].charAt(0).toUpperCase();
      } else {
        last_letter = team.charAt(team.length - 1).toUpperCase();
      }
      return first_letter + last_letter;
    },
    update_setup() {
      this.loading = false;
      this.loadTxt = null;
      this.addResults = false;
      this.addCards = false;
      this.addPlayers = false;

      this.dialog_end_match = false;

      const {
        match_started,
        match_ended,
        match_concluded,
        match_edited,
        match_period,
        match_current_time,
        first_half_done,
        team_a_fouls,
        team_b_fouls,
        papers
      } = this.oneMatch.attributes;
      // console.log({match_started});

      this.match_started =
        match_started != null ? match_started : this.match_started;
      this.match_ended = match_ended != null ? match_ended : this.match_ended;
      this.match_period =
        match_period != null ? match_period : this.match_period;
      this.match_current_time =
        match_current_time != null
          ? match_current_time
          : this.match_current_time;
      this.first_half_done =
        first_half_done != null ? first_half_done : this.first_half_done;
      this.home_fouls = team_a_fouls != null ? team_a_fouls : this.home_fouls;
      this.away_fouls = team_b_fouls != null ? team_b_fouls : this.away_fouls;

      this.match_concluded = match_concluded;
      this.match_edited = match_edited;

      this.events =
        papers != null ? papers.data.map(obj => obj.attributes) : this.events;

      if (
        this.click_ok &&
        0 < this.match_current_time &&
        this.match_current_time < 180
      )
        this.click_ok = false;
    },
    submitSquadNumbers() {
      let arr_num = [
        ...this.oneMatch.attributes.home_team_data.data.attributes.squads.data.map(
          obj => obj.attributes
        ),
        ...this.oneMatch.attributes.away_team_data.data.attributes.squads.data.map(
          obj => obj.attributes
        )
      ];

      this.oneMatch.attributes.squad_numbers_attributes = [];

      arr_num.forEach(squad => {
        let obj = {
          // match_id: this.oneMatch.id,
          squad_id: squad.id,
          number: squad.number,
          id: squad.number_id
        };
        this.oneMatch.attributes.squad_numbers_attributes.push(obj);
      });

      this.gameSquad = arr_num.filter(obj => obj.number > 0).length >= 8;

      console.log({ arr_num });
      console.log({ sqd_num_arr: this.oneMatch.attributes });

      this.loading = true;
      this.loadTxt = "Salvando";
      this.updateMatch({ match: this.oneMatch.attributes });
    },
    ...mapActions({
      indexEvent: "Championship/indexEvent",

      showMatch: "Championship/showMatch",
      showPaper: "Championship/showPaper",
      updateMatch: "Championship/updateMatch",
      updateMatchTime: "Championship/updateMatchTime",
      clearOneMatch: "Championship/clearOneMatch",

      createPaper: "Championship/createPaper",
      updatePaper: "Championship/updatePaper",
      deletePaper: "Championship/deletePaper"
    })
  },
  beforeDestroy() {
    this.clearOneMatch();
  },
  watch: {
    oneMatch(nv, ov) {
      if (nv && ov == null) {
        console.log("first time");
        setTimeout(() => {
          this.update_setup();
        }, 500);
      } else if (nv && ov != null) {
        this.update_setup();
      }
    },
    updateMatchWasGood(nv, ov) {
      if (nv) {
        // this.loading = false
        // this.loadText = null
        // this.showMatch({match_id: this.$router.currentRoute.params.id})
      } else if (nv == false) {
      }
    },
    match_started(nv, ov) {
      if (nv) {
        this.timer_loop();
      } else if (nv == false) {
      }
    },
    matchTimeCondition() {
      if (this.match_started == false) this.match_started = true;
    },
    addInfo(nv, ov) {
      if (nv) {
        this.time_event =
          (Math.trunc(this.match_current_time / 60) % 60) +
          1 +
          (this.match_period_time * this.match_period) / 60;
      } else if (nv == false) {
        this.time_event = null;
        this.own_goal = false;
      }
    },
    own_goal(nv, ov) {
      if (nv) {
        this.time_event =
          (Math.trunc(this.match_current_time / 60) % 60) +
          1 +
          (this.match_period_time * this.match_period) / 60;
      } else if (nv == false) {
        this.time_event = null;
      }
    },

    time_to_update(nv, ov) {
      if (nv % 5 == 0 && !this.match_ended) {
        console.log({ nv });
        //update match_time
        this.showMatch({ match_id: this.$router.currentRoute.params.id });
      }
    },
    match_current_time(nv, ov) {
      if (
        nv % 5 == 0 ||
        (this.match_period == 0 && nv == this.match_period_time)
      ) {
        console.log({ nv });
        //update match_time
        let obj = {
          id: this.oneMatch.id,
          match_period: this.match_period,
          match_current_time: this.match_current_time,
          match_started: this.match_started,
          first_half_done: this.first_half_done,
          match_ended: this.match_ended,

          team_a_fouls: this.home_fouls,
          team_b_fouls: this.away_fouls
        };
        if (this.is_owner && !this.match_concluded)
          this.updateMatchTime({ match: obj });
      }

      if (nv == this.match_period_time) {
        this.matchTimeCondition = 0;
        if (!this.match_concluded && !this.click_ok) {
          this.click_ok = this.$swal({
            title:
              this.match_period == 0 ? "Fim do primeiro tempo!" : "Fim do jogo",
            type: "success",
            confirmButtonText: "OK",
            confirmButtonColor: "#003a3e",
            timer: 10000
          });
        }
        if (this.match_period == 0) {
          this.match_period = 1;
          this.first_half_done = true;
          this.match_current_time = 0;
          let obj = {
            id: this.oneMatch.id,
            first_half_done: true
          };
          if (this.is_owner && !this.match_concluded)
            this.updateMatchTime({ match: obj });
        } else {
          this.match_ended = true;
          let obj = {
            id: this.oneMatch.id,
            match_ended: this.match_ended,
            match_current_time: this.match_period_time
          };
          if (this.is_owner && !this.match_concluded)
            this.updateMatchTime({ match: obj });
        }
      } else if (nv == false) {
      }
    },
    dialog_end_match(nv, ov) {
      if (nv) {
      } else if (nv == false) {
        this.ending_kind = null;
        this.winner_index = null;
        this.winner_goals = null;
        this.actual_result = true;
      }
    },
    onePaper(nv, ov) {
      if (nv) {
        this.dialog_edit_paper = true;
      } else if (nv == false) {
      }
    },
    updatePaperWasGood(nv, ov) {
      this.loading = false;
      this.loadText = null;
      if (nv) {
        this.dialog_edit_paper = false;
      } else if (nv == false) {
      }
    },
    deletePaperWasGood(nv, ov) {
      this.loading = false;
      this.loadText = null;
      if (nv) {
        this.dialog_edit_paper = false;
      } else if (nv == false) {
      }
    }
  },
  created() {
    // console.log(this.$router.currentRoute);
    // console.log(this.$router.currentRoute.path.includes('jogo'));
    this.loading = true;
    this.loadTxt = "Carregando";
    this.showMatch({ match_id: this.$router.currentRoute.params.id });
    this.indexEvent();
  },
  mounted() {
    this.timer_loop_visitor();
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}

.icon-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.icon-stack-1x,
.icon-stack-3x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.icon-stack-1x {
  line-height: inherit;
}
</style>


